<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>查询SN号</span>
                </div>
            </div>
            <div class="search_box">
                <el-form :inline="true" :model="searchData" class="demo-form-inline search-form">
                    <el-form-item label="密钥:" class="form_item">
                        <el-input placeholder="请输入密钥" clearable v-model="searchData.project_id"></el-input>
                    </el-form-item>
                    <el-form-item label="SN号:" class="form_item">
                        <el-input placeholder="请输入SN号" clearable v-model="searchData.device_name"></el-input>
                    </el-form-item>
                    <el-form-item label="状态:" class="form_item">
                        <el-select v-model="searchData.state" clearable placeholder="请选择SN状态">
                            <el-option label="可使用" value="可使用"></el-option>
                            <el-option label="使用中" value="使用中"></el-option>
                            <el-option label="已烧录" value="已烧录"></el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item>
                        <div class="button search" @click="search">
                            <span>查询</span>
                        </div>
                        <div class="button search export" @click="exportSn" v-if="roleCheck('106-102-102-102')">
                            <span>导出</span>
                        </div>
                        <div class="button search log export" @click="exportLog(false, 'time')" v-if="roleCheck('106-102-102-103')">
                            <span>产测记录导出</span>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div class="number">
                <span>{{ '总数：' + total }}</span> 
                <span>{{ '使用中：' + inUseNumber }}</span>
                <span>{{ '已使用：' + useNumber }}</span>
            </div>
            <el-table
                highlight-current-row
                :data="listData">
                <el-table-column prop="device_name" label="SN号" ></el-table-column>
                <el-table-column prop="project_id" label="密钥" v-if="roleCheck('106-102-102-104')"></el-table-column>
                <el-table-column prop="mac" label="MAC地址" ></el-table-column>
                <el-table-column label="状态" >
                    <template slot-scope="scope" >
                        <div>
                            <span class="use" v-if="scope.row.state == '已烧录'">{{ scope.row.state }}</span>
                            <span class="in_use" v-else-if="scope.row.state == '使用中'">{{ scope.row.state }}</span>
                            <span class="not_use" v-else>{{ scope.row.state }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="使用时间" >
                    <template slot-scope="scope" >
                        <span>{{ formDate(scope.row.start_time) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" >
                    <template slot-scope="scope" >
                        <div>
                            <div class="button text" @click="updateDislogShow(scope.row)" v-if="roleCheck('106-102-102-102')">编辑</div>
                            <div class="button text" @click="exportLog(scope.row.mac)" v-if="roleCheck('106-102-102-103') && scope.row.mac">产测记录导出</div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination>
            <Gh-Dialog ref="snSetting" :title="dialog.title" @dialogBack="settingConfirm">
                <template v-slot:content>
                    <el-form label-width="100px" :model="actData" ref="addProductRule">
                        <el-select v-model="actData.state" placeholder="请选择SN状态">
                            <el-option label="可使用" value="可使用"></el-option>
                            <el-option label="使用中" value="使用中"></el-option>
                            <el-option label="已烧录" value="已烧录"></el-option>
                        </el-select>
                    </el-form>
                </template>
            </Gh-Dialog>
        </div>
    </div>
    
</template>
<script>
export default({
    name: 'cb-reset-sn',
    data() {
        return {
            searchData: {
                project_id: '',
                device_name: '',
                state: '',
                page: 1,
                page_size: 10
            },
            listData: [],
            total: 0,
            useNumber: 0,
            inUseNumber: 0,
            dialog: {},
            actData: {},
        }
    },
    created() {
        this.search();
    },
    methods: {
        search() {
            if(this.searchData.project_id || this.searchData.device_name){
                this.searchData.page = 1;
                this.searchData.page_size = 10;
                this.getList();
                this.getCount();
            }
        },
        exportSn() {
            this.api.ptExportSn({project_id: this.searchData.project_id, device_name: this.searchData.device_name});
        },
        exportLog(mac, time) {
            let params = {
                mac: mac || '',
                start_time: ''
            };
            if(time) {
                var currentTimestamp = Math.floor(Date.now() / 1000);
                // 计算前30天对应的时间戳
                var thirtyDaysAgoTimestamp = currentTimestamp - (60 * 60 * 24 * 10);
                params.start_time = thirtyDaysAgoTimestamp;
            }
            this.api.ptExportM1Log(params);
        },
        getList() {
            this.api.ptGetCatBoxList(this.searchData).then(data => {
                this.listData = data.data.result;
                this.total = data.data.count || 0;
            })
        },
        getCount() {
            this.api.ptGetCatBoxNumber({project_id: this.searchData.project_id, device_name: this.searchData.device_name}).then(data => {
                this.useNumber = 0;
                this.inUseNumber = 0;
                for(let i=0; i<data.data.length; i++) {
                    if(data.data[i].State == '已烧录') {
                        this.useNumber = data.data[i].Count || 0;
                    }else if(data.data[i].State == '使用中') {
                        this.inUseNumber = data.data[i].Count || 0;
                    }
                }
            })
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getList();
        },
        updateDislogShow(item) {
            this.dialog = {
                title: '修改SN状态',
                type: 'update'
            };
            this.actData = {
                state: item.state,
                project_id: item.project_id,
                product_key: item.product_key,
                device_name: item.device_name
            };
            this.$refs.snSetting.show = true;
        },
        settingConfirm() {
            this.api.ptUploadCatBoxState(this.actData).then(data => {
                this.actData = {};
                this.$refs.snSetting.show = false;
                this.getList();
            })
            
        }
    }
})
</script>
<style lang="less" scoped>
    .button.log{
        width: 100px;
    }
    .number span{
        margin-right: 20px;
    }
    .not_use{
        color: green;
    }
    .use{
        color: @colorDel;
    }
</style>



// WEBPACK FOOTER //
// src/view/product-test-tool/cat-box/query-sn.vue